import axios from "axios";
let baseURL = "https://api.rtvslo.si";
const axiosAPI = axios.create({
    withCredentials: true,
    baseURL: baseURL
});
// implement a method to execute all the request from here.
const apiRequest = (method, url, request) => {
    const headers = {
    // authorization: ""
    };
    //using the axios instance to perform the request that received from each http method
    return axiosAPI({
        method,
        url,
        data: request,
        headers
    }).then(res => {
        return Promise.resolve(res.data);
    })
        .catch(err => {
        return Promise.reject(err);
    });
};
const get = (url, request) => apiRequest("get", url, request);
const API = {
    get
};
export default API;
